import React, { memo } from 'react'
import PropTypes from 'prop-types'

// components
import { Toolbar } from '../../../../index'
import { THEMES } from '../../../../../utils'

const propTypes = {
  toolbarTheme: PropTypes.oneOf([THEMES.STEEL, THEMES.Q4_BLUE]),
  toolTheme: PropTypes.oneOf([THEMES.Q4_BLUE, THEMES.INK])
}

const defaultProps = {
  toolbarTheme: THEMES.Q4_BLUE,
  toolTheme: THEMES.INK
}

/**
 * Contact Webcast Toolbar Component
 * @param props
 */
function ContactWebcastToolbar (props) {
  const { toolbarTheme } = props
  return (
    <Toolbar theme={toolbarTheme}></Toolbar>
  )
}

ContactWebcastToolbar.propTypes = propTypes
ContactWebcastToolbar.defaultProps = defaultProps

export default memo(ContactWebcastToolbar)
